import { fundingSearchFollowers, updateSearchFollower } from './types';

export const requestFundingSearchFollowers = (fundingSearchId) => ({
  type: fundingSearchFollowers.request,
  fundingSearchId,
});
export const requestFundingSearchFollowersSuccess = (fundingSearchId, response) => ({
  type: fundingSearchFollowers.success,
  fundingSearchId,
  response,
});
export const requestFundingSearchFollowersFailure = (fundingSearchId, error) => ({
  type: fundingSearchFollowers.failure,
  fundingSearchId,
  error,
});

export const requestUpdateSearchFollower = (fundingSearchId, userId) => ({
  type: updateSearchFollower.request,
  fundingSearchId,
  userId,
});
export const requestUpdateSearchFollowerSuccess = (fundingSearchId, response) => ({
  type: updateSearchFollower.success,
  fundingSearchId,
  response,
});
export const requestUpdateSearchFollowerFailure = (fundingSearchId, error) => ({
  type: updateSearchFollower.failure,
  fundingSearchId,
  error,
});
